// ---------------------------------------------------------
// Datei: google-identity.ts
// Zweck: Minimaler, gemeinsamer Typvertrag für Google Identity Services
// Kontext: GIS wird zentral genau einmal initialisiert; One Tap und
//          der gerenderte Button verwenden dieselbe Instanz.
// ---------------------------------------------------------

export interface GoogleCredentialResponse {
  credential?: string;
}

export interface GooglePromptMomentNotification {
  isSkippedMoment?: () => boolean;
  isDismissedMoment?: () => boolean;
  getDismissedReason?: () => string;
}

export interface GoogleIdentityApi {
  initialize: (config: {
    client_id: string;
    callback: (response: GoogleCredentialResponse) => void;
    auto_select?: boolean;
    use_fedcm_for_prompt?: boolean;
    use_fedcm_for_button?: boolean;
    itp_support?: boolean;
  }) => void;
  prompt: (listener?: (notification: GooglePromptMomentNotification) => void) => void;
  cancel: () => void;
  revoke?: (email: string, cb: () => void) => void;
  renderButton: (parent: HTMLElement, options: {
    type?: 'standard' | 'icon';
    theme?: 'outline' | 'filled_blue' | 'filled_black';
    text?: 'signin_with' | 'signup_with' | 'continue_with' | 'signin';
    shape?: 'rectangular' | 'pill' | 'circle' | 'square';
    width?: number;
  }) => void;
}

declare global {
  interface Window {
    google?: { accounts?: { id?: GoogleIdentityApi } };
  }
}

export function getGoogleIdentity(): GoogleIdentityApi | undefined {
  return window.google?.accounts?.id;
}
